import { render, staticRenderFns } from "./LinkedinBrands.vue?vue&type=template&id=6a4654ce"
import script from "./LinkedinBrands.vue?vue&type=script&lang=ts"
export * from "./LinkedinBrands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports